











































import Enterprise from '@/datatypes/enterprise';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import CustomerText from '@/components/billing/customer-text.vue';
import SubscriptionText from '@/components/billing/subscription-text.vue';
import User from '@/datatypes/user';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    enterprises: new Array<Enterprise>(),
    hasNext: true,
    user: new User({}),
    errorMessage: '',
    enterpriseSearch: {
      term: '' as string | (string | null)[],
      kind: '' as string,
    },
    nextPointer: undefined as string | undefined,
    enterpriseService: new EnterpriseService(),
    totalCount: 0,
  }),

  components: {
    CustomerText,
    SnackbarMessageHandler,
    SubscriptionText,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  computed: {
    kinds(): Array<[number, string]> {
      return this.user.kindHash.map(
        (item) => [item.kind, item.name],
      );
    },
  },

  methods: {
    routeChanged() {
      this.getEnterprises();
    },

    getQueryOptions() {
      if (
        (typeof this.enterpriseSearch.kind !== 'undefined')
        && (this.enterpriseSearch.kind !== '')
      ) {
        return {
          term: this.enterpriseSearch.term,
          kind: parseInt(this.enterpriseSearch.kind, 10),
          next: this.nextPointer,
        };
      }

      return {
        term: this.enterpriseSearch.term,
        kind: undefined,
        next: this.nextPointer,
      };
    },

    concatEnterpriseResponse(data: Enterprise[]) {
      this.enterprises = this.enterprises.concat(data);
    },

    getEnterprises() {
      this.enterpriseService.getUnbilledEnterprises(this.getQueryOptions()).then((response) => {
        this.concatEnterpriseResponse(
          response.data.map((content) => new Enterprise(camelcaseKeysDeep(content))),
        );

        if (this.enterprises.length === 0) {
          this.errorMessage = 'No businesses found.';
        }

        if (response.headers.total_count) {
          this.totalCount = response.headers.total_count;
        } else {
          this.totalCount = 0;
        }

        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }

        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.getEnterprises();
    },

    searchEnterprise() {
      this.enterprises = new Array<Enterprise>();
      this.nextPointer = undefined;
      this.getEnterprises();
    },
  },
});
